import React from "react";
import IconNegada from "../componentsStyled/icon/Iconnegada";
import { Box, Button, Modal } from "@mui/material";

interface OutOfDateModalProps {
  isOpen?: boolean;
  onRequestClose?: () => void;
  daysAllowed: number | null;
}

const OutOfDateModal: React.FC<OutOfDateModalProps> = ({ isOpen, onRequestClose, daysAllowed }) => {
  return (
    <Modal
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        width: 300,
        transform: "translate(-50%, -50%)",
        padding: 2,
        height: "fit-content",
        bgcolor: "#fff",
        boxShadow: 24,
        "& .MuiBackdrop-root": { backgroundColor: "transparent" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        borderRadius: 10,
      }}
      open={isOpen}
      onClose={onRequestClose}>
      <Box>
        <IconNegada width={60} />
        <p
          style={{
            fontWeight: 700,
            fontFamily: "Gotham",
            fontSize: 16,
            marginTop: 10,
            marginBottom: 4,
          }}>
          Poxa, Craque!
        </p>
        <br />
        <p style={{ fontSize: 13, fontFamily: "Gotham", fontWeight: 500 }}>
          Parece que o prazo para essa troca já foi <strong style={{ color: "#ff0000" }}>excedido</strong>
        </p>
        <br />
        <p style={{ fontSize: 13, fontFamily: "Gotham", fontWeight: 400 }}>
          Infelizmente não poderemos prosseguir com a sua solicitação de devolução. O prazo de devolução dos produtos dessa categoria é de {daysAllowed} dias.
        </p>
        <br />

        <Button
          sx={{
            backgroundColor: "#221F20",
            color: "#fff",
            margin: "0px auto",
            display: "block",
            borderRadius: 100,
            width: 150,
            "&:hover": {
              backgroundColor: "#808080",
              color: "#ffffff",
            },
          }}
          onClick={onRequestClose}>
          Voltar
        </Button>
      </Box>
    </Modal>
  );
};

export default OutOfDateModal;
